export default function useStoreAllowedPaymentMethods() {
  // common file dependency
  return []
}
